import keyMirror from '../../util/keyMirror';

export default keyMirror('Contacts', [
    'LOAD_CONTACTS_START',
    'LOAD_CONTACTS_SUCCESS',
    'LOAD_CONTACTS_FAIL'
]);
